import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumbPlaybook from '../components/BreadcrumbPlaybook'
import PlaybookComponent from '../components/PlaybookComponent'


export default function PlayBook() {
  return (
    <div>
      <Header1/>
      <BreadcrumbPlaybook/>
      <PlaybookComponent/>
      <Footer/>
    </div>
  )
}
